<ngx-dropzone #dropzone class="mat-elevation-z2 drop-container"
    [label]="'files.dragndrop.summary' | translate"
    (filesAdded)="onAddFiles($event)">
</ngx-dropzone>

<div class="actions-bar">
    <mat-spinner [diameter]="30" color="accent" *ngIf="isUploading && !isProcessing"></mat-spinner>

    <button mat-button type="button" class="remove-all-btn" type="button"
        [disabled]="files.length === 0 || isUploading"
        (click)="onRemoveAll()">
        {{ 'files.actions.removeAll.shortLabel' | translate }}
        <mat-icon aria-label="Cancel">clear</mat-icon>
    </button>
    <button mat-raised-button color="accent" type="button" type="button" class="start-upload-btn"
        [disabled]="files.length === 0 || isUploading"
        (click)="onUploadAll()">
        {{ 'files.actions.uploadAll.shortLabel' | translate }}
        <mat-icon aria-label="Upload">cloud_upload</mat-icon>
    </button>
</div>

<app-files-list *ngIf="!isProcessing"
    [files]="files"
    (removeFile)="onRemoveFile($event)">
</app-files-list>

<div class="processing" *ngIf="isProcessing">
    {{ 'files.processingStates.processing.summary' | translate }}
    <mat-spinner [diameter]="35" color="accent"></mat-spinner>
</div>
